import React from "react";
import { CreateChapterDto } from "../../../../interfaces/chapters.interface";
import { Question } from "../../../../interfaces/questions.interface";

interface StepThreeProps {
  values: CreateChapterDto;
}

const isValidQuestion = (question: any): question is Question => {
  return question 
    && typeof question.questionAnnouncement === 'string'
    && typeof question.answerA === 'string'
    && typeof question.answerB === 'string'
    && typeof question.answerC === 'string'
    && typeof question.answerD === 'string'
    && Array.isArray(question.correctAnswers);
};

export const StepThree: React.FC<StepThreeProps> = ({ values }) => {
  const validQuestions = values.questions?.filter(q => q !== null && isValidQuestion(q)) || [];

  return (
    <div className="step-container">
      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-medium mb-2">Informations du chapitre</h3>
          <div className="bg-gray-50 p-4 rounded-lg">
            <p><span className="font-medium">Titre:</span> {values.title}</p>
            <p><span className="font-medium">Catégorie:</span> {values.category}</p>
            <p><span className="font-medium">Description:</span> {values.description}</p>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-medium mb-2">Questions ({validQuestions.length})</h3>
          <div className="space-y-4">
            {validQuestions.map((question, index) => (
              <div key={index} className="bg-gray-50 p-4 rounded-lg">
                <p className="font-medium mb-2">Question {index + 1}: {question.questionAnnouncement}</p>
                <div className="space-y-1 ml-4">
                  <p className={question.correctAnswers.includes("A") ? "text-green-600" : ""}>
                    A: {question.answerA}
                  </p>
                  <p className={question.correctAnswers.includes("B") ? "text-green-600" : ""}>
                    B: {question.answerB}
                  </p>
                  <p className={question.correctAnswers.includes("C") ? "text-green-600" : ""}>
                    C: {question.answerC}
                  </p>
                  <p className={question.correctAnswers.includes("D") ? "text-green-600" : ""}>
                    D: {question.answerD}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
